import { PropsWithChildren } from 'react'

import AdaptiveAlert from '@/components/molecules/AdaptiveAlert'

export default function ChangePlanNotification({ children }: Readonly<PropsWithChildren>) {
  return (
    <AdaptiveAlert isMinor borderRadius="small" variant="info">
      {children}
    </AdaptiveAlert>
  )
}
